// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6404":"a5b53e5a63696d72292a","9010":"08c97acdda7d1f854677","9221":"f520b061d43078cda1ed"}[chunkId] + ".css";
};